import { useState, useEffect } from 'react';
import { getContext } from '@fiverr-private/fiverr_context';
import { ALLOCATIONS, EXPERIMENTS, ROLLOUTS } from '@fiverr-private/listing_experiments';
import { useAppContext } from '../../components/context/listingsContext';

export const useStoreBuilder = (storeBuilder) => {
    const { userId, pageCtxId, abTests } = getContext();
    const { rollouts } = useAppContext();

    const [showStoreBuilderFlow, setShowStoreBuilderFlow] = useState(false);
    const [isPopupOpenFloatingModal, setIsPopupOpenFloatingModal] = useState(false);

    const inRollout = rollouts[ROLLOUTS.HAWKS_AI_STORE_BUILDER_ENTRY_POINTS];
    const isGroupB = Number(abTests[EXPERIMENTS.HAWKS_LISTINGS_STORE_BUILDER_WIZARD_EP]) === Number(ALLOCATIONS.TEST_B);

    const shouldShowStoreBuilderToggle = inRollout && isGroupB && storeBuilder.display === 'niche';
    const shouldShowFloatingModal = inRollout && isGroupB && storeBuilder.display === 'modal';

    const pageName = 'sub_categories';
    const biEventData = {
        userId,
        ctxId: pageCtxId,
    };

    const storeBuilderToggleProps = {
        showStoreBuilderFlow,
        setStoreBuilderFlow: setShowStoreBuilderFlow,
        items: storeBuilder.data,
        biEventData,
        pageName,
    };

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY >= 400) {
                setIsPopupOpenFloatingModal(true);
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return {
        showStoreBuilderFlow,
        setShowStoreBuilderFlow,
        isPopupOpenFloatingModal,
        shouldShowStoreBuilderToggle,
        shouldShowFloatingModal,
        storeBuilderToggleProps,
        biEventData,
        pageName,
    };
};
